import { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "./App.css";
import Router from "./views";

const App = () => {
  useEffect(() => {
    if (window.google?.translate) return;

    const addGoogleTranslateScript = document.createElement("script");
    addGoogleTranslateScript.src =
      "https://translate.google.com/translate_a/element.js?cb=initGoogleTranslate";
    document.body.appendChild(addGoogleTranslateScript);

    window.initGoogleTranslate = () => {
      if (!window.google?.translate) return;
      new window.google.translate.TranslateElement(
        { pageLanguage: "ko", autoDisplay: true },
        "google_translate_element"
      );
    };
  }, []);

  const ProtectedRoute = ({ component: Component, ...rest }) => {
    const token = localStorage.getItem("authorization");
    return (
      <Route
        {...rest}
        render={(props) =>
          token ? <Component {...props} /> : <Redirect to="/signin" />
        }
      />
    );
  };

  return (
    <div className="App">
      <div id="google_translate_element" style={{ display: "none" }} />
      <Switch>
        <Route exact path="/signin" component={Router.SignIn} />
        <Route exact path="/signup" component={Router.SignUp} />
        <Route exact path="/reset-password" component={Router.ResetPassword} />
        <Route exact path="/auth-success" component={Router.AuthSuccess} />
        <Route exact path="/docs/privacy" component={Router.Privacy} />
        <Route exact path="/docs/terms" component={Router.Terms} />
        <Route exact path="/docs/marketing" component={Router.Marketing} />
        <ProtectedRoute
          exact
          path="/shipment-tracking"
          component={Router.ShipmentTracking}
        />
        <ProtectedRoute path="/" component={Router.Main} />
      </Switch>
    </div>
  );
};

export default App;
